module.exports = __webpack_public_path__ + "static/palabok-b81cb4ee335f3a0f371e83df0796767e.jpg";